import { createSlice } from '@reduxjs/toolkit';
import { filter } from 'lodash';
import Axios from '../../utils/axiosInstance';

const initialState = {
  notificationList: [],
  notification: null,
  notificationIdData: [],
  notificationId: null,
};

const slice = createSlice({
  name: 'notification',
  initialState,
  reducers: {
    // START LOADING
    startLoading(state) {
      state.isLoading = true;
    },

    // HAS ERROR
    hasError(state, action) {
      state.isLoading = false;
      state.error = action.payload;
    },
    setWorkshopId: (state, action) => {
      state.notificationId = action.payload;
    },

    // DELETE Notification
    deleteNotification(state, action) {
      const deleteNotification = filter(
        state.notification,
        (notification) => notification.id !== action.payload,
      );
      state.notification = deleteNotification;
    },

    // GET Notification
    getNotificationListSuccess(state, action) {
      state.isLoading = false;
      state.notificationList = action.payload;
    },

    // Create Notification
    createNotification(state, action) {
      state.isLoading = false;
      state.notification = action.payload;
    },
    NotificationFindByID(state, action) {
      state.isLoading = false;
      state.notificationIdData = action.payload;
    },
  },
});

// Reducer
export default slice.reducer;

// Actions
export const { onToggleFollow, deleteNotification } = slice.actions;

// ----------------------------------------------------------------------

export function dispatchDeleteNotification(notificationId) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      await Axios.delete(`notification-invoice/${notificationId}`);
      dispatch(slice.actions.deleteNotification(notificationId));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

// ----------------------------------------------------------------------

export function dispatchUpdateNotification(notification) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await Axios.put(`notification-invoice/${notification.id}`, notification);
      dispatch(slice.actions.createNotification(response.data.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

// ----------------------------------------------------------------------

export function getNotificationList() {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await Axios.get('notification-invoice');
      dispatch(slice.actions.getNotificationListSuccess(response.data.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

// ----------------------- Notification id find -------------------------------------

export function getNotificationFindByID(id) {
  return async (dispatch) => {
    if (!id) return;

    dispatch(slice.actions.startLoading());
    try {
      const response = await Axios.get(`notification-invoice/${id}`);
      dispatch(slice.actions.NotificationFindByID(response.data.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}
